/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { RtSystemManufacturer } from './RtSystemManufacturer';
import {
    RtSystemManufacturerFromJSON,
    RtSystemManufacturerFromJSONTyped,
    RtSystemManufacturerToJSON,
} from './RtSystemManufacturer';
import type { FileMetaInfoDto } from './FileMetaInfoDto';
import {
    FileMetaInfoDtoFromJSON,
    FileMetaInfoDtoFromJSONTyped,
    FileMetaInfoDtoToJSON,
} from './FileMetaInfoDto';
import type { RtSystemCategory } from './RtSystemCategory';
import {
    RtSystemCategoryFromJSON,
    RtSystemCategoryFromJSONTyped,
    RtSystemCategoryToJSON,
} from './RtSystemCategory';
import type { MedicalSystemSubCategory } from './MedicalSystemSubCategory';
import {
    MedicalSystemSubCategoryFromJSON,
    MedicalSystemSubCategoryFromJSONTyped,
    MedicalSystemSubCategoryToJSON,
} from './MedicalSystemSubCategory';

/**
 * 
 * @export
 * @interface CreateImagingMachineDto
 */
export interface CreateImagingMachineDto {
    /**
     * 
     * @type {string}
     * @memberof CreateImagingMachineDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateImagingMachineDto
     */
    description?: string | null;
    /**
     * 
     * @type {RtSystemCategory}
     * @memberof CreateImagingMachineDto
     */
    category: RtSystemCategory;
    /**
     * 
     * @type {RtSystemManufacturer}
     * @memberof CreateImagingMachineDto
     */
    manufacturer: RtSystemManufacturer;
    /**
     * 
     * @type {string}
     * @memberof CreateImagingMachineDto
     */
    model: string;
    /**
     * 
     * @type {string}
     * @memberof CreateImagingMachineDto
     */
    subModel?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateImagingMachineDto
     */
    imageId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateImagingMachineDto
     */
    isAvailable?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateImagingMachineDto
     */
    isArchived?: boolean;
    /**
     * 
     * @type {Array<FileMetaInfoDto>}
     * @memberof CreateImagingMachineDto
     */
    attachments?: Array<FileMetaInfoDto> | null;
    /**
     * 
     * @type {string}
     * @memberof CreateImagingMachineDto
     */
    typeSpecification?: string | null;
    /**
     * 
     * @type {MedicalSystemSubCategory}
     * @memberof CreateImagingMachineDto
     */
    subCategory: MedicalSystemSubCategory;
    /**
     * 
     * @type {string}
     * @memberof CreateImagingMachineDto
     */
    trackItAlias?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateImagingMachineDto
     */
    serialNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateImagingMachineDto
     */
    $type?: CreateImagingMachineDtoTypeEnum;
}


/**
 * @export
 */
export const CreateImagingMachineDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedMedicalSystemComponentDtoDescriptionsCreateImagingMachineDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.Descriptions.CreateImagingMachineDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CreateImagingMachineDtoTypeEnum = typeof CreateImagingMachineDtoTypeEnum[keyof typeof CreateImagingMachineDtoTypeEnum];



/**
 * Check if a given object implements the CreateImagingMachineDto interface.
 */
export function instanceOfCreateImagingMachineDto(value?: unknown): value is CreateImagingMachineDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CreateImagingMachineDtoTypeEnum)[0];
}

export function CreateImagingMachineDtoFromJSON(json: any): CreateImagingMachineDto {
    return CreateImagingMachineDtoFromJSONTyped(json, false);
}

export function CreateImagingMachineDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateImagingMachineDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'category': RtSystemCategoryFromJSON(json['category']),
        'manufacturer': RtSystemManufacturerFromJSON(json['manufacturer']),
        'model': json['model'],
        'subModel': json['subModel'] == null ? undefined : json['subModel'],
        'imageId': json['imageId'] == null ? undefined : json['imageId'],
        'isAvailable': json['isAvailable'] == null ? undefined : json['isAvailable'],
        'isArchived': json['isArchived'] == null ? undefined : json['isArchived'],
        'attachments': json['attachments'] == null ? undefined : ((json['attachments'] as Array<any>).map(FileMetaInfoDtoFromJSON)),
        'typeSpecification': json['typeSpecification'] == null ? undefined : json['typeSpecification'],
        'subCategory': MedicalSystemSubCategoryFromJSON(json['subCategory']),
        'trackItAlias': json['trackItAlias'] == null ? undefined : json['trackItAlias'],
        'serialNumber': json['serialNumber'] == null ? undefined : json['serialNumber'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function CreateImagingMachineDtoToJSON(value?: CreateImagingMachineDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'name': value['name'],
        'description': value['description'],
        'category': RtSystemCategoryToJSON(value['category']),
        'manufacturer': RtSystemManufacturerToJSON(value['manufacturer']),
        'model': value['model'],
        'subModel': value['subModel'],
        'imageId': value['imageId'],
        'isAvailable': value['isAvailable'],
        'isArchived': value['isArchived'],
        'attachments': value['attachments'] == null ? undefined : ((value['attachments'] as Array<any>).map(FileMetaInfoDtoToJSON)),
        'typeSpecification': value['typeSpecification'],
        'subCategory': MedicalSystemSubCategoryToJSON(value['subCategory']),
        'trackItAlias': value['trackItAlias'],
        'serialNumber': value['serialNumber'],
        '$type': value['$type'],
    });
}

